const CIRCUMFERENCE = 2 * Math.PI * 55;

function getRingColor(pct: number, id?: string): string {
  if (id === 'extra-class') {
    if (pct > 30) return '#4aba6a';
    if (pct >= 10) return '#f0a030';
    return '#e24b4a';
  }
  if (id === 'submissions') {
    // Homework completion is measured against an inflated denominator (all
    // exercises in attended classes, incl. unassigned/extra-class content), so
    // even diligent students land low. Thresholds are scaled accordingly.
    if (pct >= 25) return '#4aba6a'; // green: 25%+
    if (pct >= 10) return '#f0a030'; // orange: 10–25%
    return '#e24b4a'; // red: 0–10%
  }
  if (pct >= 75) return '#4aba6a';
  if (pct >= 50) return '#f0a030';
  return '#e24b4a';
}

export function StatRing({ label, percentage, delay = 0, id }: { label: string; percentage: number; delay?: number; id: string }) {
  const clamped = Math.max(0, Math.min(100, percentage));
  const color = getRingColor(clamped, id);
  const offset = CIRCUMFERENCE - (clamped / 100) * CIRCUMFERENCE;
  const animName = `ring-fill-${id}`;

  return (
    <div className="flex flex-col items-center">
      <style>{`
        @keyframes ${animName} {
          from { stroke-dashoffset: ${CIRCUMFERENCE}; }
          to { stroke-dashoffset: ${offset}; }
        }
      `}</style>
      <div className="relative h-[110px] w-[110px] sm:h-[130px] sm:w-[130px]">
        <svg viewBox="0 0 140 140" className="h-full w-full" style={{ transform: 'rotate(-90deg)' }}>
          <circle cx="70" cy="70" r="55" fill="none" stroke="#e8e9ed" strokeWidth="10" />
          <circle
            cx="70" cy="70" r="55"
            fill="none"
            strokeWidth="10"
            strokeLinecap="round"
            stroke={color}
            strokeDasharray={CIRCUMFERENCE}
            strokeDashoffset={CIRCUMFERENCE}
            style={{
              animation: `${animName} 1s ease-out ${delay}ms forwards`,
            }}
          />
        </svg>
        <span className="absolute inset-0 flex items-center justify-center text-center text-xs font-medium leading-tight text-gray-900 sm:text-[13px]">
          <span className="max-w-[75px]">{label}</span>
        </span>
      </div>
    </div>
  );
}
